import React from 'react';
import { useTranslation } from 'react-i18next';
import TechsightIcon from '../../assets/techsight.svg';
import css from './TechsightWidget.module.scss';

export const TechsightWidget: React.FC = () => {
    const { t } = useTranslation('App');

    return (
        <>
            <div className={css.middleContainer}>
                <div className={css.icon}>
                    <TechsightIcon />
                </div>
                <div>{t('Solve smarter: your one-stop information source')}</div>
            </div>
        </>
    );
};
